import React, { useState } from "react";
import { Box, Button, Typography, Paper, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getUrl } from "src/Utils/Common";
import axios from "axios";
import { setUserProject } from "src/Redux/userPojectSlice/userProjectSlice";
import MarketeersBackground from "./MarketeersBackground";
import backgroundProject from "src/Assets/MarketeersLogo.png";

const UploadExcel = () => {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      setFile(e.target.files[0]);
      setError("");
    }
  };

  const handleUpload = () => {
    if (!file) {
      setError("Please select an Excel file.");
      return;
    }

    setLoading(true);
    const formData = new FormData();
    formData.append("file", file);

    axios.post(`${getUrl()}/free_trial/upload_temp_excel`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        "x-access-token": localStorage.getItem("userId") || "",
        "x-cors-api-key": "temp_8c8f91f122df0ef9daa49a6701f13f76",
      },
    })
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          console.log("Upload successful", response.data);
          const responseData = response.data || {};
          const rawProjectId =
            responseData.project_id ?? responseData.projectId ?? responseData.id;
          const parsedProjectId = Number(rawProjectId);

          if (!Number.isFinite(parsedProjectId)) {
            setError("Upload succeeded but project id is missing in response.");
            return;
          }

          dispatch(
            setUserProject({
              userId: localStorage.getItem("userId"),
              projectId: parsedProjectId,
            })
          );
          // Redirect to platform dashboard
          navigate("/dashboard");
        }
      })
      .catch((err) => {
        console.error("Error uploading file:", err);
        setError("Error uploading file. Please try again.");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Grid container sx={{ height: "100vh" }}>
      <Grid item xs={12} md={6}>
        <MarketeersBackground src={backgroundProject} />
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: "#F4F6FB",
          p: { xs: 2, sm: 4 },
        }}
      >
        <Paper
          elevation={4}
          sx={{
            width: "100%",
            maxWidth: 480,
            borderRadius: 4,
            p: { xs: 3, sm: 4 },
            boxShadow: "0 14px 35px rgba(0,0,0,0.08)",
          }}
        >
          <Box mb={2} textAlign="left">
            <Typography variant="overline" sx={{ color: "#929292", letterSpacing: 1 }}>
              Upload Data
            </Typography>
            <Typography variant="h5" sx={{ fontWeight: "bold", color: "primary.main" }}>
              Upload Trial Data
            </Typography>
            <Typography variant="body2" sx={{ mt: 0.5, color: "#555" }}>
              Please upload your Excel data to begin your free trial.
            </Typography>
          </Box>

          {error && (
            <Typography color="error" sx={{ marginBottom: 2, fontWeight: "700" }}>
              {error}
            </Typography>
          )}

          <Box sx={{ my: 3 }}>
            <input
              type="file"
              accept=".xls,.xlsx"
              onChange={handleFileChange}
              style={{ display: "none" }}
              id="raised-button-file"
            />
            <label htmlFor="raised-button-file">
              <Button variant="outlined" component="span" fullWidth sx={{ borderRadius: 3, py: 1.5 }}>
                {file ? file.name : "Choose Excel File"}
              </Button>
            </label>
          </Box>

          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={handleUpload}
            disabled={loading || !file}
            sx={{
              borderRadius: 3,
              fontWeight: "bold",
              textTransform: "uppercase",
              py: 1,
            }}
          >
            {loading ? "Uploading..." : "Upload and Continue"}
          </Button>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default UploadExcel;
